import { useDialog } from '@xemplo/use-dialog';

import { UseModalDialogProps } from './modal-dialog.types';

export const useModalDialog = ({
  id,
  closeOnOutsideClick = true,
}: UseModalDialogProps) => {
  const { dialogRef, ...rest } = useDialog({ closeOnOutsideClick });
  return {
    ...rest,
    dialogProps: {
      ref: dialogRef,
      id,
      autoFocus: true,
    },
  };
};
